import React, { useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import PlansModal from "./trataz-home/PlansModal";
import DifferencesModal from "./trataz-home/DifferencesModal";
import FaqModal from "./trataz-home/FaqModal";
import FindProfessionalModal from "./trataz-home/FindProfessionalModal";
import PrivacyPolicyModal from "./trataz-home/PrivacyPolicyModal";
import { differencesItems, faqItems } from "./trataz-home/data";
import {
  HeroSection,
  SectionTwo,
  SectionThree,
  SectionFour,
  SectionFive,
  SectionSeven,
  SectionEight,
  SectionNine,
} from "./trataz-home/sections";

const Page = styled.div`
  ${tw`min-h-screen`}
  background: #fff;
  position: relative;
  overflow: hidden;
`;

const FloatingTratiWhatsApp = styled.a`
  position: fixed;
  right: 26px;
  bottom: 26px;
  z-index: 9999;
  width: 76px;
  height: 76px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  border-radius: 999px;
  border: 3px solid #b39a3a;
  background: linear-gradient(180deg, #ffffff 0%, #dceceb 45%, #4f8884 100%);
  box-shadow: 0 14px 24px rgba(0, 0, 0, 0.22);
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;

  &:hover {
    filter: brightness(1.03);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(1px) scale(0.98);
    box-shadow: 0 9px 16px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 767px) {
    right: 16px;
    bottom: 16px;
    width: 62px;
    height: 62px;
    border-width: 2px;
  }
`;

const FloatingTratiImage = styled.img`
  width: 58px;
  height: auto;
  display: block;
  transform: translateY(7px);
  pointer-events: none;

  @media (max-width: 767px) {
    width: 48px;
    transform: translateY(4px);
  }
`;

export default function TratazHomeLandingPage() {
  const [plansModalOpen, setPlansModalOpen] = useState(false);
  const [differencesModalOpen, setDifferencesModalOpen] = useState(false);
  const [faqModalOpen, setFaqModalOpen] = useState(false);
  const [privacyPolicyModalOpen, setPrivacyPolicyModalOpen] = useState(false);
  const [findProfessionalModalOpen, setFindProfessionalModalOpen] =
    useState(false);

  const openPlansModal = (event) => {
    event.preventDefault();
    setPlansModalOpen(true);
  };

  const closePlansModal = () => setPlansModalOpen(false);
  const openDifferencesModal = (event) => {
    event?.preventDefault?.();
    setDifferencesModalOpen(true);
  };
  const closeDifferencesModal = () => setDifferencesModalOpen(false);
  const openFaqModal = (event) => {
    event?.preventDefault?.();
    setFaqModalOpen(true);
  };
  const closeFaqModal = () => setFaqModalOpen(false);
  const openFindProfessionalModal = (event) => {
    event?.preventDefault?.();
    setFindProfessionalModalOpen(true);
  };
  const closeFindProfessionalModal = () => setFindProfessionalModalOpen(false);
  const openPrivacyPolicyModal = (event) => {
    event?.preventDefault?.();
    setPrivacyPolicyModalOpen(true);
  };
  const closePrivacyPolicyModal = () => setPrivacyPolicyModalOpen(false);

  return (
    <AnimationRevealPage>
      <Page>
        <HeroSection
          onOpenPlans={openPlansModal}
          onOpenFindProfessional={openFindProfessionalModal}
        />

        <SectionTwo onOpenPlans={openPlansModal} />

        <SectionThree onOpenPlans={openPlansModal} />

        <SectionFour />

        <SectionFive
          onOpenDifferences={openDifferencesModal}
          onOpenFaq={openFaqModal}
        />

        <SectionSeven onOpenPlans={openPlansModal} />

        <SectionEight onOpenPlans={openPlansModal} />

        <SectionNine onOpenPrivacyPolicy={openPrivacyPolicyModal} />

        <PlansModal isOpen={plansModalOpen} onRequestClose={closePlansModal} />
        <DifferencesModal
          isOpen={differencesModalOpen}
          onRequestClose={closeDifferencesModal}
          items={differencesItems}
        />
        <FaqModal
          isOpen={faqModalOpen}
          onRequestClose={closeFaqModal}
          items={faqItems}
        />
        <FindProfessionalModal
          isOpen={findProfessionalModalOpen}
          onRequestClose={closeFindProfessionalModal}
        />
        <PrivacyPolicyModal
          isOpen={privacyPolicyModalOpen}
          onRequestClose={closePrivacyPolicyModal}
        />

        <FloatingTratiWhatsApp
          href="https://wa.me/5547996912977"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Falar com a Trati no WhatsApp"
        >
          <FloatingTratiImage
            src="/novas-imagens/section-seven/trati.png"
            alt=""
            loading="lazy"
            decoding="async"
          />
        </FloatingTratiWhatsApp>
      </Page>
    </AnimationRevealPage>
  );
}
